import { readBoardUserSetting } from './read'
import { resourceObject } from './resourceObject'
import { updateBoardUserSetting } from './update'

export const boardUserSetting = {
  clientResource: resourceObject,
  readSingle: readBoardUserSetting,
  update: updateBoardUserSetting,
}
